import React, { Component } from "react";
import { connect } from "react-redux";
import Map from "ol/Map";
import PropTypes from "prop-types";
import VectorSource from "ol/source/Vector";
import Select from "ol/interaction/Select";
import { click } from "ol/events/condition";
import VectorLayer from "ol/layer/Vector";
import GeoJSON from "ol/format/GeoJSON";
import { toLonLatExtent } from "../../../../../lib/map/core/transfomer";
import { BasicOverlay, FeaturesLayer } from "../../../../../lib/map";
// import Label from '../../../../../components/lv/Label';

/**
 * Layer component for displaying an array of Openlayers features.
 */
class ArcGISPolygonFeatureLayer extends Component {
  /**
   * Property types.
   */
  static propTypes = {
    /**
     * Features to display in this layer.
     */
    features: PropTypes.array,
    /**
     * A unique key to indentify this layer.
     */
    id: PropTypes.number,
    /**
     * layer name
     */
    name: PropTypes.string,
    /**
     * The instance of map this layer is attached to. The map instance
     * will be provided to the component automatically when used as a
     * child component of the <Map/>.
     */
    map: PropTypes.instanceOf(Map),
    /**
     * Called when the feature is just about to be added to the vector source.
     */
    onAddFeature: PropTypes.func,
    /**
     * Called when layer has been added to the map.
     */
    onAddLayer: PropTypes.func,
    /**
     * The style function applied to each feature.
     */
    onFeatureStyle: PropTypes.func,
    /**
     * Called when layer has been removed from the map.
     */
    onRemoveLayer: PropTypes.func,
    /**
     * Called after vector source populated with features.
     */
    onAfterPopulateFeatures: PropTypes.func,
    /**
     * Whether or not this layer is visible.
     */
    visible: PropTypes.bool,
    /**
     * The z-index to order this layer in the map layers stack.
     */
    zIndex: PropTypes.number,

    /**
     * current extent of the map
     */
    extent: PropTypes.array,

    /**
     * layer url from db
     */
    url: PropTypes.string,
    /**
     * Whether or not the layer is interactive.
     */
    interactive: PropTypes.bool,
    /**
     * metadata out fields
     */
    metadataOutFields: PropTypes.string
  };

  /**
   * Default properties for those props that are not required.
   */
  static defaultProps = {
    features: undefined,
    id: Math.random() * 1000000 + "",
    map: undefined,
    onAddFeature: undefined,
    onAddLayer: undefined,
    onFeatureStyle: undefined,
    interactive: true,
    onRemoveLayer: undefined,
    visible: true,
    zIndex: 999
  };

  constructor(props) {
    super(props);

    this.state = {
      position: undefined,
      features: undefined
    };
    /**
     * Provides source of features for vector layers.
     */
    this.vectorSource = new VectorSource();

    /**
     * The layer hosting the source vector.
     */
    this.vectorLayer = new VectorLayer({
      id: props.id,
      visible: props.visible,
      source: this.vectorSource,
      style: props.onFeatureStyle,
      zIndex: props.zIndex
    });

    this.geoJsonFormat = new GeoJSON();

    this.handleOnSelect = this.handleOnSelect.bind(this);
    this.handleOnAddFeature = this.handleOnAddFeature.bind(this);
    this.handleOnCloseOverlay = this.handleOnCloseOverlay.bind(this);
    this.addFeaturesToState = this.addFeaturesToState.bind(this);
    this.selectFilter = this.selectFilter.bind(this);

    this.interactionSelect = new Select({
      condition: click,
      filter: this.selectFilter
    });
  }

  selectFilter(feature, layer) {
    if (this.state.features && this.state.features.length > 0) {
      return this.state.features.includes(feature);
    }

    return false;
  }

  handleOnAddFeature(feature) {
    // feature.setStyle(SiteFeaturesLayer.featureStyle(feature, false));
  }

  addFeaturesToState(features) {
    this.setState({
      features: features
    });
  }

  handleOnCloseOverlay() {
    this.setState({
      position: undefined,
      feature: undefined
    });

    this.interactionSelect.getFeatures().forEach(each => {
      // each.setStyle(SiteFeaturesLayer.featureStyle(each, false));
    });
    this.interactionSelect.getFeatures().clear();
  }

  overlayTitle() {
    return this.props.layerName;
  }

  componentDidMount() {
    this.interactionSelect.on("select", this.handleOnSelect);
    this.props.map.addInteraction(this.interactionSelect);

    this.props.map.getLayers().push(this.vectorLayer);

    if (this.props.onAddLayer) {
      this.props.onAddLayer(this.vectorLayer);
    }

    this.popuplateLayerFeatures();
  }

  handleOnSelect(e) {
    const that = this;
    const p = e.mapBrowserEvent.coordinate;

    e.deselected.forEach(function(each) {
      that.setState({
        position: undefined,
        feature: undefined
      });
      // each.setStyle(SiteFeaturesLayer.featureStyle(each, false));
    });

    e.selected.forEach(function(each) {
      that.setState({
        position: p,
        feature: each
      });
      // each.setStyle(SiteFeaturesLayer.featureStyle(each, true));
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.visible !== prevProps.visible) {
      this.vectorLayer.setVisible(this.props.visible);
      if (this.props.visible) {
        this.popuplateLayerFeatures();
      }
    }
  }

  componentWillUnmount() {
    this.props.map.removeLayer(this.vectorLayer);

    if (this.props.removeLayer) {
      this.props.onRemoveLayer(this.vectorLayer);
    }

    this.vectorSource = null;
    this.vectorLayer = null;
  }

  /**
   * Adds the features to the vector layer.
   */
  popuplateLayerFeatures() {
    var self = this;
    let stdExtent = toLonLatExtent(this.props.extent);
    this.fetchFeatureVectors(this.props.url, this.props.extent)
      .then(response => {
        self.vectorSource.clear();

        var features = self.geoJsonFormat.readFeatures(response, {
          featureProjection: "EPSG:3857",
          dataProjection: "EPSG:4326"
        });

        features.forEach(function(feature) {
          let outFieldArray = self.props.metadataOutFields.split(",");
          let info = {
            layerType: "arcgisvector",
            layerName: self.props.layerName,
            id: feature.id,
            kvp: []
          };
          if (outFieldArray.length > 0) {
            outFieldArray.forEach(function(item) {
              let itemTrimmed = item.trim();
              info.kvp.push({
                key: itemTrimmed,
                value: feature.get(itemTrimmed)
              });
            });
          }
          feature.set("metadata", info);
        });
        this.addFeaturesToState(features);
      })
      .catch(error => console.log(error));
  }

  fetchFeatureVectors(url, extent) {
    let urlFormatted = url + `query?where=1%3D1&outFields=*&returnGeometry=true&f=geojson`;

    return fetch(urlFormatted)
      .then(response => response.json())
      .catch(() => console.log("error at fetchFeatureVectors"));
  }

  render() {
    return (
      <FeaturesLayer
        id={this.props.id}
        map={this.props.map}
        zIndex={this.props.zIndex}
        features={this.state.features}
        onAddLayer={this.handleOnAddLayer}
        onAddFeature={this.handleOnAddFeature}
        visible={true}
      ></FeaturesLayer>
    );
  }
}

function mapStateToProps(state) {
  return {
    criteria: state.map.search.criteria,
    extent: state.map.extent,
    zoom: state.map.zoom
  };
}

export default connect(mapStateToProps)(ArcGISPolygonFeatureLayer);
